<div
  class="app-button-group"
  [ngClass]="[
    'app-button-group--' + render
  ]">
  <ng-content></ng-content>
</div>